import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  useTranslate,
  EditButton,
  DeleteButton,
  ArrayField,
  DateField,
  usePermissions,
} from 'react-admin';
import ListActions from '../../components/ListActions';
import LicensesFilter from '../../components/LicensesFilter';
import TourLicenses from './TourLicenses';

const LicensesList = (props) => {
  const translate = useTranslate();
  const { permissions } = usePermissions();
  return (
    <List
      {...props}
      sort={{ field: 'updatedAt', order: 'DESC' }}
      actions={
        <ListActions
          {...props}
          tourConfig={TourLicenses({ translate })}
          hideFilters
        />
      }
      bulkActionButtons={permissions === 'ADMIN'}
      filters={<LicensesFilter />}
    >
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField source="name" label={translate('custom.general.name')} />
        <TextField source="status" label={translate('custom.general.status')} />
        <ArrayField
          source="courses"
          fieldKey="id"
          label={translate('custom.courses.title')}
        >
          <Datagrid>
            <TextField source="name" />
            <TextField source="status" />
          </Datagrid>
        </ArrayField>
        <DateField
          label={translate('custom.licenses.startDate')}
          source="startDate"
          showTime
        />
        <DateField
          label={translate('custom.licenses.endDate')}
          source="endDate"
          showTime
        />
        <DateField
          label={translate('custom.general.createdAt')}
          source="createdAt"
          showTime
        />
        <DateField
          label={translate('custom.general.updatedAt')}
          source="updatedAt"
          showTime
        />
        <EditButton data-testid="Licenses-edit" />
        {permissions === 'ADMIN' && (
          <DeleteButton data-testid="Licenses-delete" />
        )}
      </Datagrid>
    </List>
  );
};

export default LicensesList;
